module.exports = __webpack_public_path__ + "static/media/SignBackground.35b19016.jpg";